import useAppModal from 'hooks/useAppModal';
import PropertiesSelectModal, {
  PROPERTIES_SELECT_MODAL_ID,
} from './PropertiesSelectModal';

const usePropertiesSelectModal = () => {
  const { openModal } = useAppModal();

  const openPropertiesSelectModal = ({
    onUpdate,
    selectedProperties,
  }: {
    onUpdate: (properties: string[]) => void;
    selectedProperties: string[];
  }) => {
    openModal({
      id: PROPERTIES_SELECT_MODAL_ID,
      customContent: (
        <PropertiesSelectModal
          onUpdate={onUpdate}
          selectedProperties={selectedProperties}
        />
      ),
    });
  };

  return {
    openPropertiesSelectModal,
  };
};

export default usePropertiesSelectModal;
